import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TableExport } from '../schemas'
import { TableExportQuery } from '../schemas'

interface ExportState {
  byTable: Record<string, { busy: boolean; job: TableExport | null; error: string | null }>
}
const initialState: ExportState = { byTable: {} }
const slice = createSlice({
  name: 'tableExports',
  initialState,
  reducers: {
    start(state, action: PayloadAction<{ tableId: string; query: TableExportQuery }>) {
      if (state.byTable[action.payload.tableId]?.busy) return
      state.byTable[action.payload.tableId] = { busy: true, job: null, error: null }
    },
    received(state, action: PayloadAction<{ tableId: string; job: TableExport }>) {
      const { tableId, job } = action.payload
      state.byTable[tableId] = { busy: job.status === 'pending' || job.status === 'running', job, error: job.error }
    },
    failed(state, action: PayloadAction<{ tableId: string; error: string }>) {
      state.byTable[action.payload.tableId] = { busy: false, job: null, error: action.payload.error }
    },
  },
})
export const ExportActions = slice.actions
export default slice.reducer
